import axios from './axios-instance';

export function createUserApi(data) {
  return axios.post('/unioncenter/tenant/create', data);
}
